export default __webpack_public_path__ + "static/media/ratifika_white.6ae8f572.svg";